import { useEffect, useState } from "react";
export const PRESENCE_MS = 240;
const HIDDEN_PANE_FALLBACK_MS = 100;
export function usePresence(isOpen, durationMs = PRESENCE_MS) {
    const [isMounted, setIsMounted] = useState(isOpen);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(()=>{
        if (isOpen) {
            setIsMounted(true);
            let inner = 0;
            const show = ()=>setIsVisible(true);
            const outer = requestAnimationFrame(()=>{
                inner = requestAnimationFrame(show);
            });
            const fallback = setTimeout(show, HIDDEN_PANE_FALLBACK_MS);
            return ()=>{
                cancelAnimationFrame(outer);
                cancelAnimationFrame(inner);
                clearTimeout(fallback);
            };
        }
        setIsVisible(false);
        const timer = setTimeout(()=>setIsMounted(false), durationMs);
        return ()=>clearTimeout(timer);
    }, [
        isOpen,
        durationMs
    ]);
    return {
        isMounted,
        isVisible
    };
}
